import { useEmployeeListAPIInterface } from "@dealer-center/ddc-pages-employee-list-fetch";

import { useEffect, useState } from "react";
import { PagesEmployeeListUiDisplay } from "./Display";

export const PagesEmployeeListUi = () => {
  const [nameInput, setNameInput] = useState("");
  const [name, setName] = useState("");
  const { data, error, isLoading } = useEmployeeListAPIInterface({ name });
  useEffect(() => {
    document.title = "EmployeeList";
  }, []);
  return (
    <PagesEmployeeListUiDisplay
      data={data}
      error={error ? error.message : undefined}
      loading={isLoading}
      nameInput={nameInput}
      setName={setName}
      setNameInput={setNameInput}
    />
  );
};
